import React, { useEffect, useState } from "react";
import buttonImage from "../../assets/images/auto_subtitle.png";
import { Languages } from "../languages";
import { IAddSubtitleButtonProps } from "./addSubtitleButton.types";
import "../../styles/styles.scss";

export function AddSubtitleButton({
  getSubtitleData,
  messenger,
  handleInvoke
}: IAddSubtitleButtonProps) {
  const [audioUrl, setAudioUrl] = useState("");
  const [videoUrls, setVideoUrls] = useState([] as any);
  const [maxLength, setMaxLength] = useState(20);
  const [startTime, setStartTime] = useState(0);
  const [endTime, setEndTime] = useState(0);
  const [videoDuration, setVideoDuration] = useState(0);
  const [error, setError] = useState(false);
  const [showLanguages, setShowLanguages] = useState(true);

  useEffect(() => {
    if (window.location.href.includes("flagEnable=true")) {
      
      messenger.read(["project.data"], processProjectData);
    }
  },[]);
  
  const handleClick = async (e: any) => {
    e.preventDefault();
    setShowLanguages(true)
    messenger.read(["project.data"], processProjectData);
  };

  const processProjectData = (res: any) => {
    const urls = res.data["project.data"].clips.map((item: any) => {
      return item.remoteUrl;
    });

    const canvasWidth = res.data?.["project.data"]?.canvasWidth || 1080;
    setMaxLength(canvasWidth/60)
    const ele: any = [];
    res.data["project.data"].clips.map(
      (item: any) => {
        if (item.subType === "video" && item.type === "mp4") {

          ele.push({
            id: item.id,
            url: item.remoteUrl,
            start: item.time.timeRange[0] * 1000,
            end: item.time.timeRange[1] * 1000,
            startTime: item.time.startTime,
            duration: item.time.duration,
          });
        }
      }
    );

    const startTime = res.data["project.data"].clips.map(
      (item: any) => {
        return item.time;
      }
    );


    setVideoUrls(ele);

    startTime.map((newItem: any) => {
      setVideoDuration(newItem.duration);
      setStartTime(newItem.startTime);
      setEndTime(0);
    });

    urls.map((item: any) => {      
      setAudioUrl(item);
    });
  };

  return (
    <div className="container">
      {audioUrl && showLanguages && (
        <Languages
          startTime={startTime}
          endTime={endTime}
          videoUrl={audioUrl}
          getSubtitleData={getSubtitleData}
          maxLength={maxLength}
          videoUrls={videoUrls}
          setShowLanguages={setShowLanguages}
          handleInvoke={handleInvoke}
        />
      //   ) : (
      //     <div>
      //       <div className="btn-container" onClick={handleClick}>
      //         <img
      //           src={buttonImage}
      //           height={"50px"}
      //           width={"321px"}
      //           alt="Auto_Subtitle"
      //         />
      //       </div>
      //       <div>
      //         {error && (
      //           <div
      //             id="alert_message"
      //             style={{
      //               alignItems: "center",
      //               display: "none",
      //               zIndex: 999,
      //               position: "absolute",
      //             }}
      //           >
      //             <span
      //               style={{
      //                 fontSize: "15px",
      //                 fontWeight: "400",
      //                 fontFamily: "Inter",
      //                 color: "#ff0000",
      //                 marginTop: "-5em",
      //                 position: "fixed",
      //                 marginLeft: "20px",
      //               }}
      //             >
      //               Please add one or more video in the timeline
      //             </span>
      //           </div>
      //         )}
      //       </div>
      //     </div>
      )}
    </div>
  );
}
